import { Link, useOutletContext, useNavigate } from "react-router-dom";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import React, { useState, useEffect, useRef } from "react";
import { getTradingVideos, incrementView, shareVideo } from "../api/user";
import { SmallShareIcon } from "../icons/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faTimes } from "@fortawesome/free-solid-svg-icons";

const categoryMap = {
  Beginner: 1,
  Intermediate: 2,
  Advanced: 3,
};

const TradingFloor = () => {
  const isMobileView = document.body.clientWidth <= 768;
  const [sidebarToggle] = useOutletContext();
  const [activeTab, setActiveTab] = useState("Beginner");
  const [videos, setVideos] = useState([]);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const videoRefs = useRef([]);
  const [muted, setMuted] = useState(true);
  const [loadingStates, setLoadingStates] = useState(
    Array(videos.length).fill(true)
  );
  const toggleMute = () => setMuted((prev) => !prev);
  const [loadingVideoId, setLoadingVideoId] = useState(null);

  // 1 April
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emails, setEmails] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  const fetchVideos = async (category) => {
    try {
      setLoading(true);
      const response = await getTradingVideos({
        category_id: categoryMap[category],
      });
      setVideos(response.data.videos || []);
      setFilteredVideos(response.data.videos || []);
    } catch (error) {
      console.error("Failed to fetch videos:", error);
      setVideos([]);
      setFilteredVideos([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideos(activeTab);
  }, [activeTab]);

  const handleVideoView = async (id) => {
    try {
      await incrementView({ id: id });
      console.log(`View incremented for post ID: ${id}`);
    } catch (error) {
      console.error("Error tracking video view:", error);
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = { day: "2-digit", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    if (!value) {
      setFilteredVideos(videos);
    } else {
      const filtered = videos.filter(
        (video) =>
          video.title.toLowerCase().includes(value) ||
          video.description.toLowerCase().includes(value)
      );
      setFilteredVideos(filtered);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          console.log("entry");

          if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
            video.play().catch(console.error);
          } else {
            video.pause();
            video.currentTime = 0;
          }
        });
      },
      { threshold: 0.8 }
    );

    videoRefs.current.forEach((video) => {
      if (video) {
        observer.observe(video);

        video.addEventListener("ended", () => {
          video.currentTime = 0;
          video.play().catch(console.error);
        });
      }
    });

    return () => {
      videoRefs.current.forEach((video) => video && observer.unobserve(video));
      observer.disconnect();
    };
  }, [videos, filteredVideos]);

  const handleLoadedData = (index) => {
    const video = videoRefs.current[index];

    if (video) {
      const checkPlayTime = () => {
        if (video.currentTime >= 0) {
          setLoadingStates((prev) => {
            const newStates = [...prev];
            newStates[index] = false;
            return newStates;
          });
          video.removeEventListener("timeupdate", checkPlayTime);
        }
      };

      video.addEventListener("timeupdate", checkPlayTime);

      // Ensure loader is shown initially
      setLoadingStates((prev) => {
        const newStates = [...prev];
        newStates[index] = true;
        return newStates;
      });
    }
  };

  const handleVideoClick = (index) => {
    const video = videoRefs.current[index];
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };

  const handleShare = async (id) => {
    const categoryValue = categoryMap[activeTab] || 1;
    const urlToShare = `https://app.qushi.io/trading-detail/${id}/${categoryValue}`;

    const shareData = {
      title: "QUSHI",
      text: "Check this out",
      url: urlToShare,
    };
    try {
      if (navigator.share) {
        await navigator.clipboard.writeText(urlToShare);
        await navigator.share(shareData);
      } else {
        const el = document.createElement("textarea");
        el.value = urlToShare;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        const shareLinkPrompt = `Link copied\nShare this link: ${urlToShare}`;
        alert(shareLinkPrompt);
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

//   const newhandleShare = (id) => {
//     setSelectedId(id);
//     setIsModalOpen(true);
//   };

// const handleShare = async () => {
//   const emailList = emails.split(",").map((email) => email.trim());
//   const categoryValue = categoryMap[activeTab] || 1;

//   console.log(emailList, "email list is");
//   console.log(selectedId, "selected id is");
//   console.log(categoryValue, "category is");

//   const requestData = {
//     emails: emailList,
//     video_id: selectedId,
//     category: categoryValue,
//   };

//   try {
//     const response = await shareVideo(requestData);
//     console.log("Video shared successfully:", response.data);
//     alert("Video shared successfully!");
//   } catch (error) {
//     alert("Failed to share video. Please try again.");
//   }
// };


  const renderDesktopView = (filteredVideos) => (
    <div className="pt-7 md:pl-8 pl-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
      {filteredVideos.length > 0 ? (
        filteredVideos.map((video) => (
          <div
            key={video.id}
            className="cursor-pointer hover:shadow-lg transition-shadow"
            onClick={() =>
              navigate(`/trading-floor/${video.id}/${video.category_id}`)
            }
          >
            <div className="border border-[#E3EDF6] overflow-hidden rounded bg-[#F8FAFC]">
              <div className="relative">
                <img
                  src={
                    video.thumbnail ||
                    video.VideoThumbnail ||
                    "https://placehold.co/600x400"
                  }
                  //src={"https://placehold.co/600x400"}
                  alt={video.title}
                  className="w-full h-40 object-contain"
                />
                <img
                  src="/Play.svg"
                  alt="Play Video"
                  className="absolute inset-y-2/4 left-0 right-0 m-auto"
                />
              </div>
              <div className="p-5">
                <h3 className="font-medium text-sm sm:text-base leading-5 sm:leading-6">
                  {video.title}
                </h3>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className="text-center col-span-full">No videos available.</p>
      )}
    </div>
  );

  const renderMobileView = (filteredVideos) => (
    <div className="mt-1">
      {filteredVideos.length > 0 ? (
        filteredVideos.map((videoItem, index) => (
          <div
            key={index}
            style={{ marginBottom: "20px", borderBottom: "1px solid #e5e7eb" }}
          >
            <div style={{ position: "relative", width: "100%" }}>
              <div onClick={() => handleVideoClick(index)}>
                {loadingStates[index] && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        border: "4px solid green",
                        borderTop: "4px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    <style>
                      {`@keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }`}
                    </style>
                  </div>
                )}

                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  src={videoItem.video}
                  playsInline
                  muted={muted}
                  loop={false}
                  style={{ width: "100%", display: "block" }}
                  onPlay={() => handleVideoView(videoItem.id)}
                  onLoadedData={() => handleLoadedData(index)}
                />
              </div>
              <button
                onClick={toggleMute}
                className="absolute bottom-4 right-4 px-4 py-2 bg-black/60 text-white text-sm rounded-full shadow-md"
              >
                {muted ? "🔇" : "🔊"}
              </button>
            </div>
            <div className="px-3.5 py-4">
              <div className="flex gap-2 justify-between">
                <h3 className="font-semibold text-base mb-1.5 w-[calc(100%-20px)]">
                  {videoItem.title}
                </h3>
                <button onClick={() => handleShare(videoItem.id)}>
                  {SmallShareIcon}
                </button>
              </div>
              <ul className="flex gap-5 mb-1">
                <li className="flex items-center text-[#999999] gap-1 text-[12px]">
                  {" "}
                  <img src="/Eye.svg" alt="" className="w-[15px]" />
                  {videoItem.views}
                </li>
                <li className="flex items-center text-[#999999] gap-1 text-[12px]">
                  <img src="/Date.svg" alt="" className="w-[15px]" />
                  {videoItem.created_at
                    ? formatDate(videoItem.created_at)
                    : "N/A"}
                </li>
              </ul>
              <p className="text-[#999999] text-sm">{videoItem.description}</p>
            </div>
          </div>
        ))
      ) : (
        <p className="text-center col-span-full">No videos available.</p>
      )}
      {/* {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h3 className="text-lg font-semibold mb-4">Enter Emails</h3>
            <textarea
              className="w-full p-2 border border-gray-300 rounded-md"
              value={emails}
              onChange={(e) => setEmails(e.target.value)}
              placeholder="Enter emails, separated by commas"
            />
            <div className="mt-4 flex justify-end space-x-2">
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                onClick={handleShare}
              >
                Share
              </button>
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title="Trading Floor" />
      <PageContainer>
        <div className="w-full">
          <div className="flex sm:justify-between justify-center items-center border-b md:border-t tf_scrollbar">
            <div className="flex overflow-x-auto">
              {Object.keys(categoryMap).map((level) => (
                <button
                  key={level}
                  className={`sm:py-4 sm:px-5 py-3 px-4 text-sm sm:text-base whitespace-nowrap ${
                    activeTab === level
                      ? "!text-primaryColor font-semibold border-b-2 border-primaryColor"
                      : "text-gray-500"
                  }`}
                  onClick={() => setActiveTab(level)}
                >
                  {level}
                </button>
              ))}
            </div>
          </div>
          <div className="max-sm:text-center md:px-4 px-0">
            <div className="my-4 relative inline-block">
              <input
                type="text"
                placeholder="Search by title or description..."
                value={searchTerm}
                onChange={handleSearch}
                className="border rounded-full text-sm w-full px-3 py-2 !pr-9 focus:outline-none focus:border-green-300 bg-slate-50 md:w-[250px]"
              />
              <div className="absolute right-0 top-0">
                <FontAwesomeIcon
                  className={
                    isMobileView ? "-ml-7 mt-3 mb-1" : "-ml-8 mb-2 mt-3"
                  }
                  icon={faMagnifyingGlass}
                />
              </div>
            </div>
          </div>

          {loading ? (
            <p className="text-center mt-4">Loading videos...</p>
          ) : isMobileView ? (
            renderMobileView(filteredVideos)
          ) : (
            renderDesktopView(filteredVideos)
          )}
        </div>
      </PageContainer>
    </>
  );
};

export default TradingFloor;
